import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line jsx-a11y/alt-text -- The alt text is part of `...props`
export const MediaImg = (props)=>/*#__PURE__*/ _jsx("img", {
        ...props
    });
